import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import {
  getPathAovProgressBarOverview,
  getPathBackInStockOverview,
  getPathReviewsOverview,
  getPathReperksOverview,
  getPathRecommenderOverview,
  getPathPromptOverview
} from 'paths/Extensions';

export * from 'paths/Accounts';
export * from 'paths/Affiliates';
export * from 'paths/Alerts';
export * from 'paths/Auth';
export * from 'paths/Billing';
export * from 'paths/Control';
export * from 'paths/Contacts';
export * from 'paths/Custom';
export * from 'paths/Data';
export * from 'paths/Ecommerce';
export * from 'paths/Emails';
export * from 'paths/Extensions';
export * from 'paths/Partners';
export * from 'paths/Sources';
export * from 'paths/Workflows';
export * from 'paths/Resources';
export * from 'paths/Users';


//=====================================================
// Paths
//=====================================================
// Main Paths
export function getPathHome() {
  return `/`;
}

export function getPathAccountPrompt() {
  return `/account-prompt`;
}

export function getPathDetectAccount() {
  return `/detect-account`;
}

export function getPathStoreConnectionExists() {
  return `/store-connection-exists`;
}

export function getPathDuplicateConnectionExists() {
  return `/duplicate-connection-exists`;
}

export function getPathCatalog(qs={}) {
  return urlUtils.appendQueryString(`/catalog`, qs);
}

export function getPathProvisionAccount() {
  return `/provision-account`;
}

export function getPathProvisionProduct() {
  return `/provision-product`;
}

export function getPathMarketingPlatformOverview(qs={}) {
  return urlUtils.appendQueryString(`/marketing-platform-overview`, qs);
}

export function getPathMarketingPlatformAnalytics(qs={}) {
  return urlUtils.appendQueryString(`/marketing-platform-analytics`, qs);
}

export function getProductHome(product) {
  if (product === constants.PRODUCT_MARKETING_PLATFORM) return getPathMarketingPlatformOverview();
  if (product === constants.PRODUCT_AOV_PROGRESS_BAR) return getPathAovProgressBarOverview();
  if (product === constants.PRODUCT_BACK_IN_STOCK) return getPathBackInStockOverview();
  if (product === constants.PRODUCT_REVIEWS) return getPathReviewsOverview();
  if (product === constants.PRODUCT_REPERKS) return getPathReperksOverview();
  if (product === constants.PRODUCT_RECOMMENDER) return getPathRecommenderOverview();
  if (product === constants.PRODUCT_PROMPT) return getPathPromptOverview();
  return "";
}



